/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Error_Title_Required1Inputs */

const vi_cmspost_error_title_required1 = /** @type {(inputs: Cmspost_Error_Title_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tiêu đề bài viết.`)
};

/**

* @param {Cmspost_Error_Title_Required1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_title_required1 = /** @type {((inputs?: Cmspost_Error_Title_Required1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Title_Required1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_title_required1(inputs)
});
export { cmspost_error_title_required1 as "cmsPost_error_title_required" }